import { makeObservable, observable, runInAction, computed } from "mobx";
import { RootStore } from "./RootStore";
import { Immunoglobulin } from "../models/Immunoglobulin";
import { FieldGroupId } from "../lib/enums";
import { convertFormsToImmunoglobulins } from "../utils/formHelpers";
import { FormGetResponse } from "../models/Form";
import {
  getLatestBasedOnDate,
  getSingleLatestBasedOnDate,
} from "../utils/dateHelpers";

class ImmunoglobulinStore {
  rootStore: RootStore;
  immunoglobulins: Immunoglobulin[] | undefined = undefined;

  constructor(rootStore: RootStore) {
    this.rootStore = rootStore;

    makeObservable(this, {
      immunoglobulins: observable,
      latestImmunoglobulins: computed,
      singleLatestImmunoglobulin: computed,
    });
  }

  get latestImmunoglobulins() {
    if (this.immunoglobulins) {
      return getLatestBasedOnDate(this.immunoglobulins) as Immunoglobulin[];
    }
    return [] as Immunoglobulin[];
  }

  get singleLatestImmunoglobulin() {
    if (this.immunoglobulins) {
      return getSingleLatestBasedOnDate(this.immunoglobulins) as Immunoglobulin;
    }
    return undefined;
  }

  setImmunoglobulins(newImmunoglobulins: Immunoglobulin[] | undefined) {
    runInAction(() => {
      this.immunoglobulins = newImmunoglobulins ?? [];
    });
  }

  getImmunoglobulins = async () => {
    const forms = await this.rootStore.formStore.getFormsByFormId(
      FieldGroupId.IMMUNOGLOBULIN_FIELD_GROUP_ID
    );
    this.setImmunoglobulins(
      convertFormsToImmunoglobulins(forms as FormGetResponse[])
    );
  };
}

export default ImmunoglobulinStore;
